import React from 'react'
import Grid from '@material-ui/core/Grid'
import { JurisdictionType, WageAmount, WageAmountLabel } from './detail/styles'
import { formatCurrency } from '../../common/helpers'
import { StyledExternalLink } from '../../theme/Global'

const tippedWage = function (jurisdiction, jurisdictionType) {
  return (
    <React.Fragment>
      <Grid item xs={2}>
        <WageAmount>{formatCurrency(jurisdiction.tipped.wage)}</WageAmount>
      </Grid>
      <Grid item xs>
        <WageAmountLabel>Tipped Wage</WageAmountLabel>
        <JurisdictionType>{jurisdictionType}</JurisdictionType>
      </Grid>
    </React.Fragment>
  )
}

const gratuitiesLink = function (performScroll) {
  return (
    <React.Fragment>
      <Grid item xs={6}>
        <StyledExternalLink onClick={() => {
          performScroll('Gratuities')
        }}
        >
            View Gratuities Section
        </StyledExternalLink>
      </Grid>
    </React.Fragment>
  )
}

export default function TippedWage({ isTipped, jurisdiction, jurisdictionType, hasMultipleTippedWages, performScroll }) {
  // if company has tipped employees, then...
  if (isTipped) {
    // if we've calculated a wage, display it
    if (jurisdiction && jurisdiction.tipped && jurisdiction.tipped.wage) {
      return tippedWage(jurisdiction, jurisdictionType)
    }

    // if we haven't calculated a wage and multiple tipped wages is a factor, let the reader calculate it themselves
    if (hasMultipleTippedWages) {
      return gratuitiesLink(performScroll)
    }
  }
  return null
}
